"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Modal = _interopRequireDefault(require("../common/Modal/Modal"));
var _APAutoTabInput = _interopRequireDefault(require("../common/APAutoTabInput/APAutoTabInput"));
var _APLabelWithText = _interopRequireDefault(require("../common/APLabelWithText/APLabelWithText"));
var _APIcon = _interopRequireDefault(require("../common/APIcon"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _clipboardHelper = _interopRequireDefault(require("../../helpers/clipboardHelper"));
var _formValidations = require("../../helpers/formValidations");
require("./GetGoogle2FARecoveryKeyModal.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('recovery-2fa-modal');
var GetGoogle2FARecoveryKeyModal = function GetGoogle2FARecoveryKeyModal(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('auth'),
    t = _useTranslation.t;
  var handleSubmit = props.handleSubmit,
    isOpen = props.isOpen,
    close = props.close,
    _onCancel = props.onCancel,
    recoveryForm = props.recoveryForm,
    showSnack = props.showSnack;
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: isOpen,
    title: t('Get Google 2FA Recovery Code'),
    close: close,
    onCancel: function onCancel() {
      _onCancel();
      close();
    }
  }, /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: handleSubmit,
    className: baseClasses()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('text-item')
  }, t('Recovery')), /*#__PURE__*/_react["default"].createElement(_APAutoTabInput["default"], {
    label: t('Type Authentication Code Here'),
    name: "code",
    type: "number",
    numberOfInputs: 6,
    validate: [_formValidations.required]
  }), recoveryForm.values.recoveryKey && /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('recovery-code-container'),
    onClick: function onClick() {
      showSnack({
        id: 'RECEIVE_RECOVERY_CODE_COPY',
        text: t('The Recovery Code has been copied to the clipboard.')
      });
      (0, _clipboardHelper["default"])(recoveryForm.values.recoveryKey);
    }
  }, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    className: baseClasses('copy-recovery-code'),
    name: "recoveryKey",
    label: "Copy Recovery Code to the clipboard"
  }), recoveryForm.values.recoveryKey, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
    name: "copy",
    customClass: baseClasses('copy-icon')
  }))));
};
GetGoogle2FARecoveryKeyModal.defaultProps = {
  handleSubmit: function handleSubmit() {},
  submitting: false
};
GetGoogle2FARecoveryKeyModal.propTypes = {
  close: _propTypes["default"].func.isRequired,
  showSnack: _propTypes["default"].func.isRequired,
  recoveryForm: _propTypes["default"].object.isRequired,
  onCancel: _propTypes["default"].func.isRequired,
  handleSubmit: _propTypes["default"].func
};
var _default = exports["default"] = GetGoogle2FARecoveryKeyModal;